import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';
import { EmptyState } from '@/components/ui/EmptyState';
import { Skeleton } from '@/components/ui/Skeleton';

export interface ChartFrameProps {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  /** Altura da área do gráfico em px. */
  height?: number;
  loading?: boolean;
  empty?: boolean;
  emptyMessage?: string;
  footer?: ReactNode;
  className?: string;
  children: ReactNode;
}

/** Moldura comum: título, ações, estados de carregamento e vazio. */
export function ChartFrame({
  title,
  description,
  actions,
  height = 280,
  loading,
  empty,
  emptyMessage = 'Sem dados no período selecionado.',
  footer,
  className,
  children,
}: ChartFrameProps) {
  return (
    <section className={cn('surface-card flex flex-col', className)}>
      <header className="flex flex-col gap-2 px-4 pb-2 pt-4 sm:flex-row sm:items-start sm:justify-between sm:px-5">
        <div className="min-w-0">
          <h3 className="text-sm font-semibold text-fg">{title}</h3>
          {description && <p className="mt-0.5 text-xs text-muted">{description}</p>}
        </div>
        {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
      </header>

      <div className="px-2 pb-3 sm:px-3" style={{ minHeight: height }}>
        {loading ? (
          <div className="p-2">
            <Skeleton className="w-full" style={{ height }} />
          </div>
        ) : empty ? (
          <EmptyState compact title="Sem dados" description={emptyMessage} />
        ) : (
          children
        )}
      </div>

      {footer && <div className="border-t border-line px-4 py-2.5 text-xs text-muted sm:px-5">{footer}</div>}
    </section>
  );
}
